import { render, staticRenderFns } from "./AgentAssistAdmin.vue?vue&type=template&id=0041f51c"
import script from "./AgentAssistAdmin.vue?vue&type=script&lang=js"
export * from "./AgentAssistAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports